// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ImageViewGrid from './data'

export default function ImageViewGridFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/ImageViewGrid">
      <ImageViewGrid {...props}>
        {children}
      </ImageViewGrid>
    </Flow>
  )
}
